"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.notificationsSelectors = void 0;
const reselect_1 = require("reselect");
const notificationState = (state) => state.notifications;
const selectToastNotificationsQueue = (0, reselect_1.createSelector)(notificationState, (notifications) => notifications.toastNotificationsQueue);
exports.notificationsSelectors = {
    selectToastNotificationsQueue,
};
